import { Modal } from "antd";
import styled from "styled-components";

export const Styles = styled.div`
  &:has(.gantt_tooltip_container) {
    .container_main {
      z-index: 1111;
    }
  }
  .main {
    padding: 24px;
    min-height: calc(100vh - 48px);
    padding-bottom: 0px;
    background: #f0f2f5;
    overflow-y: scroll;
    overflow-x: hidden;

    &:has(.tab-custom-page) {
      height: calc(100vh - var(--header-height, 48px)) !important;
      min-height: calc(100vh - var(--header-height, 48px)) !important;
      overflow: hidden !important;
    }

    &:has(.react-grid-layout) {
      overflow-y: unset;
      overflow-x: unset;
    }

    &:has(.gantt_tooltip_container) {
      margin: 24px;
      padding: 0 !important;
      overflow-x: unset;
      overflow-y: unset;
      min-height: calc(100vh - 96px);
    }

    &:has(.business_rpg) {
      overflow-y: unset;
      overflow-x: unset;
      padding-right: 12px !important;
    }

    &:has(.business-rpg-page) {
      overflow-y: unset;
      overflow-x: unset;
      padding: 0px !important;
    }

    &::-webkit-scrollbar {
      width: 0px;
      height: 0px;
    }
    // override left style default of Tooltip Gannt chart
    ._25P-K {
      left: auto !important;
      white-space: normal !important;
      word-break: break-word !important;
      max-width: 100% !important;
    }
  }
`;

export const StylesWrapButton = styled.div`
  position: relative;
  .wrap-button {
    position: fixed;
    z-index: 2;
    left: 102px;
    top: 50px;
  }

  button {
    &.btn-back {
      background: #ffffff;
      border: 1px solid #174a83;
      color: #174a83;
      width: 40px;
      min-width: 40px;
    }

    &.active {
      background: #1890ff;
      color: #fff;
    }
  }
`;

export const WorkerInviteStyles = styled(Modal)`
  .ant-modal-content {
    border-radius: 8px;
    .ant-modal-header {
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      padding: 10px 16px;
      background: #174a83;
      .ant-modal-title {
        color: #fff;
      }

      .icon-warning {
        background: #3d5674;
        width: 25px;
        height: 25px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        opacity: 0.9;
      }
    }
    .ant-modal-body {
      padding: 8px 16px;
      display: flex;
      flex-direction: column;
      max-height: 360px;
      overflow-y: auto;
    }
    .form-invite {
      margin-top: 10px;
    }

    .invite-item.ant-form-item {
      margin-bottom: 0px;
      border-left: 1px solid #f0f0f0;
      border-right: 1px solid #f0f0f0;
      border-top: 1px solid #f0f0f0;
      padding: 0;

      &:last-child {
        border-bottom: 1px solid #f0f0f0;
      }
    }

    .invite-item .ant-form-item-row {
      display: grid;
      grid-template-columns: 260px 1fr;
      align-items: stretch;
      gap: 0;
    }

    .invite-item .ant-form-item-label {
      margin-bottom: 0;
      border-right: 1px solid #f0f0f0;
      display: flex;
      align-items: center;
      height: 100%;

      > label {
        height: 100%;
        width: 100%;
        display: block;
        padding: 4px 8px;
        white-space: normal;
        word-break: break-word;
        overflow-wrap: anywhere;
        text-align: left;

        &::before {
          display: none !important;
        }

        &::after {
          display: none !important;
        }
      }
    }

    .invite-item .ant-form-item-control {
      height: 100%;
      width: 136px;
    }

    .invite-item .ant-form-item-control-input {
      min-height: 0px;
      height: 100%;
    }

    .invite-item .ant-form-item-control-input-content {
      display: flex;
      align-items: center;
      padding: 0px 4px;
      height: 100%;
    }

    .invite-item .ant-radio-group {
      display: flex;
      align-items: center;
      height: 100%;
      .vertical {
        height: 100%;
        width: 1px;
        background: #f0f0f0;
      }
    }
    .invite-item .ant-radio-wrapper {
      margin-right: 0px;

      &:last-of-type {
        padding-left: 4px;
      }
    }

    .noti-item {
      border: 1px solid #f0f0f0;
      border-radius: 4px;
      padding: 8px;
      display: flex;
      flex-direction: column;
      gap: 8px;
      margin-bottom: 8px;
    }
    .noti-item p {
      white-space: pre-line;
      font-size: 12px;
      color: #606266;
      font-weight: 400;
      line-height: 16px;
    }
    .noti-item ul {
      margin: 0;
      padding-left: 20px;
    }

    .noti-item ul li {
      list-style-type: disc !important;
      list-style-position: outside;
      display: list-item;
      font-size: 14px;
      color: #606266;
      font-weight: 400;
      line-height: 16px;
    }

    .ant-modal-footer {
      .btn-submit {
        width: 90px;
        min-width: 90px;
        height: 34px !important;
      }
      padding: 8px 16px;
    }
  }
`;
